<template>
  <b-button :disabled="disabled" :class="[buttonClass, { 'inactive': disabled }]" @click="onClick">
    <slot name="svg"></slot>
    <div v-if="!small" class="text"> {{ buttonText }}</div>
  </b-button>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    onClick: {
      type: Function,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    buttonClass() {
      let classes = this.primary ? 'btn-primary' : this.secondary ? 'btn-secondary' : '';
      if (this.small) {
        classes += ' small';
      }
      return classes;
    }
  }
}
</script>

<style scoped>
button {
  display: flex;
  gap: 5px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: var(--margin-s) var(--margin-l);
}

button.small {
  padding: 0px;
  background-color: transparent!important;
}
button.disabled {
  padding: var(--margin-s) var(--margin-l) !important;
}
.btn-secondary {
  background-color: var(--color-gray-200);
  border: none;
}

.inactive {
  opacity: 0.2 !important;
}
</style>